<script>
export default {
    name: 'SvgIcon',
    props: {
        name: {
            type: String,
            required: true,
        },
        width: {
            type: [String, Number],
            default: '24',
        },
        height: {
            type: [String, Number],
            default: '24',
        },
        className: {
            type: String,
            default: '',
        },
    },
};
</script>

<template>
    <svg :class="className" :width="width" :height="height" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" :style="{ minWidth: height }">
        <use :xlink:href="`#icon-${name}`" />
    </svg>
</template>
